export enum AssetType {
    DEVICE = "DEVICE",
    ZONE = "ZONE",
    THIRD_PARTY_DEVICE = "THIRD_PARTY_DEVICE",
    AREA_OF_INTEREST = "AREA_OF_INTEREST",
    SENSOR = "SENSOR",
    VALVE = "VALVE",
    PUMP = "PUMP",
    HYDRAULIC_NODE = "HYDRAULIC_NODE",
    GATEWAY = "GATEWAY",
    ORGANIZATION = "ORGANIZATION",
}

export interface AssetTypeConfiguration {
    /** Single-letter prefix used in the verdiId (e.g. "D" produces IDs like "D-SAP-300") */
    verdiIdPrefix: string;
    /** Total digit count for the numeric suffix of the verdiId */
    verdiIdDigitCount: 3 | 4;
}

export const assetTypeConfigurationsByType = {
    [AssetType.DEVICE]: { verdiIdPrefix: "D", verdiIdDigitCount: 3 },
    [AssetType.ZONE]: { verdiIdPrefix: "Z", verdiIdDigitCount: 3 },
    [AssetType.THIRD_PARTY_DEVICE]: { verdiIdPrefix: "X", verdiIdDigitCount: 3 },
    [AssetType.AREA_OF_INTEREST]: { verdiIdPrefix: "A", verdiIdDigitCount: 3 },
    [AssetType.SENSOR]: { verdiIdPrefix: "S", verdiIdDigitCount: 4 },
    [AssetType.VALVE]: { verdiIdPrefix: "V", verdiIdDigitCount: 4 },
    [AssetType.PUMP]: { verdiIdPrefix: "P", verdiIdDigitCount: 3 },
    [AssetType.HYDRAULIC_NODE]: { verdiIdPrefix: "H", verdiIdDigitCount: 4 },
    [AssetType.GATEWAY]: { verdiIdPrefix: "G", verdiIdDigitCount: 3 },
    [AssetType.ORGANIZATION]: { verdiIdPrefix: "O", verdiIdDigitCount: 3 },
} as const satisfies Record<AssetType, AssetTypeConfiguration>;
